interface IPresetVideo {
  description?: string;
  text: string;
  thumbnail: string;
  videoSrc: string;
}

export const presetVideos: IPresetVideo[] = [
  {
    videoSrc: "https://eleven-public-cdn.elevenlabs.io/payloadcms/8lb4n8vbi98-mountains_noaudio.mp4",
    text: "Drone shot of mountains",
    thumbnail: "https://eleven-public-cdn.elevenlabs.io/payloadcms/i3xsk9p19ub-mountains_thumbnail.webp",
  },
  {
    videoSrc:
      "https://eleven-public-cdn.elevenlabs.io/payloadcms/r9bebxbyqmr-Futuristic_Soldiers_Slow_Mo_Video_noaudio.mp4",
    text: "Futuristic soldiers",
    thumbnail:
      "https://eleven-public-cdn.elevenlabs.io/payloadcms/117dfjb97e68-Futuristic_Soldiers_Slow_Mo_Video_thumbnail.webp",
  },
  {
    videoSrc: "https://eleven-public-cdn.elevenlabs.io/payloadcms/edsucgmqhkr-Victorian_Tea_in_Manor_House_noaudio.mp4",
    text: "Afternoon tea in manor house",
    thumbnail:
      "https://eleven-public-cdn.elevenlabs.io/payloadcms/xf0wzmpbkfc-Victorian_Tea_in_Manor_House_thumbnail.webp",
  },
  {
    videoSrc:
      "https://eleven-public-cdn.elevenlabs.io/payloadcms/l2c99hjij-Pirates_Dancing_Drinking_Singing_noaudio.mp4",
    text: "Pirates",
    thumbnail:
      "https://eleven-public-cdn.elevenlabs.io/payloadcms/lmclwr5hbx-Pirates_Dancing_Drinking_Singing_thumbnail.webp",
  },
];
